import { render, staticRenderFns } from "./AddAgents.vue?vue&type=template&id=e10acd12&scoped=true&"
import script from "./AddAgents.vue?vue&type=script&lang=js&"
export * from "./AddAgents.vue?vue&type=script&lang=js&"
import style0 from "./AddAgents.vue?vue&type=style&index=0&id=e10acd12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10acd12",
  null
  
)

export default component.exports